module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLightIt.ttf?a80f946aa15fe5e72b2ea3f34b84c09f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLightIt.ttf
// module id = 1396
// module chunks = 0